/** Shared chart palette — maps to Tailwind primary / success / warning / danger. */
export const CHART_COLORS = {
  primary: '#9333ea',
  primarySoft: '#c084fc',
  accent: '#2563eb',
  accentSoft: '#60a5fa',
  success: '#16a34a',
  successSoft: '#4ade80',
  warning: '#d97706',
  warningSoft: '#fbbf24',
  danger: '#e11d48',
  dangerSoft: '#fb7185',
  slate: '#64748b',
  slateSoft: '#94a3b8',
  track: '#e2e8f0',
};

/** Rotating series colors for multi-segment charts. */
export const SERIES_PALETTE = [
  CHART_COLORS.primary,
  CHART_COLORS.accent,
  CHART_COLORS.success,
  CHART_COLORS.warning,
  CHART_COLORS.danger,
  '#0d9488',
  '#7c3aed',
  '#ea580c',
];

export const tooltipStyle = {
  borderRadius: 12,
  border: '1px solid #e2e8f0',
  boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
  fontSize: 12,
};

export const axisTick = { fill: '#64748b', fontSize: 11 };
